      @if(internalPagedMatters != null) {
        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">{{element.status}}</td>
          </ng-container>

          <ng-container matColumnDef="items">
            <th mat-header-cell *matHeaderCellDef>Items</th>
            <td mat-cell *matCellDef="let element">{{element.completedDocumentCount}}/{{element.requiredDocumentCount}}</td>
          </ng-container>


          <ng-container matColumnDef="link">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"><mat-icon>chevron_right</mat-icon></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['/matters', row.id]"></tr>
        </table>
        <div class="text-align-center" *ngIf="internalPagedMatters.items.length === 0">There are currently no matters here.</div>
      }
